<template>
	<div class="bg-gray">
		<a-spin :spinning="loading">
			<div class="content">
				<div class="head-bg" :style="`background: url(${headBg}) no-repeat;backgroundSize:cover;`"></div>
				<div class="container">
					<div class="nav">
						<a-breadcrumb separator=">">
							<a-breadcrumb-item>
								<router-link
									:to="{path:'/',query:{menuPosition:'1481846823343697922'}}">首页</router-link>
							</a-breadcrumb-item>
							<a-breadcrumb-item>
								<router-link :to="{path:$route.fullPath}">{{firstMenuName}}</router-link>
							</a-breadcrumb-item>
							<a-breadcrumb-item>
								<router-link :to="{path:$route.fullPath}">{{secondMenuName}}</router-link>
							</a-breadcrumb-item>
						</a-breadcrumb>
						<div class="reback" @click="reback">
							返回
							<a-icon type="rollback" />
						</div>
					</div>
					<div class="main">
						<div class="slide">
							<div class="item" :class="currentMenuGroup==item.HomeMenu.id?'active':''"
								v-for="(item,index) in searchMenu" @click="changeGroup(item.HomeMenu.id)">
								<div class="title flex align-center">
									<div class="line"></div><span class="margin-left-5">{{item.HomeMenu.menu}}</span>
								</div>
								<div class="item-content">
									<ul>
										<li :class="$route.query.newsType==child.id?'active':''"
											v-for="(child,childIndex) in item.newsType">
											<router-link class="line-1"
												:to="{path:'/news/list',query:{homeMenuFirstId:currentMenuGroup,menuPosition:menuPosition,newsType:child.id}}">
												{{child.newsType}}</router-link>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="main-content margin-bottom-15">
							<div class="list">
								<div class="item" v-for="(item,index) in newsList" v-if="newsList!=''">
									<router-link style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: block; width: 80%;" :to="{path:'/news/info',query:{newsId:item.id}}">{{item.newsTitle}}
									</router-link><span>{{item.releaseTime}}</span>
								</div>
							</div>
							<div v-if="newsList==''" class="padding-top-15">
								<a-empty style="padding:50px;" description="暂无新闻数据" />
							</div>
							<div class="margin-top-30 text-center" v-if="newsList!=''">
								<a-pagination show-quick-jumper :default-current="newsListObj.current"
									:total="newsListObj.total" @change="onChange" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</a-spin>
		<div class="clear"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				headBg: require("../../assets/news_bg.png"),
				menuPosition: "",
				currentMenuGroup: "",
				newsList: [], //新闻列表
				newsListObj: {},
				searchMenu: [], //左侧搜索菜单
				current: 1,
				firstMenuName: "",
				secondMenuName: "",
				loading: true,
			}
		},
		mounted() {
			this.menuPosition = this.$route.query.menuPosition;
			this.currentMenuGroup = this.$route.query.homeMenuFirstId;
			this.getHeadBanner();
			this.getSearchMenu();
			this.getNewsList();
			console.log(this.$route);

		},
		methods: {
			// 获取面包屑导航名称
			getNavName() {
				setTimeout(() => {
					let slideName = document.querySelector(".slide .active .title span").innerText;
					this.firstMenuName = slideName;
					let secondName = document.querySelector(".item-content .active a").innerText;
					this.secondMenuName = secondName;
				}, 500)
			},
			getNavNameNotTimeOut() {
				let slideName = document.querySelector(".slide .active .title span").innerText;
				this.firstMenuName = slideName;
				let secondName = document.querySelector(".item-content .active a").innerText;
				this.secondMenuName = secondName;
			},
			getHeadBanner() {
				this.$request({
					url: this.$api.public.getBanner,
					data: {
						menuPosition: 2,
						type: 1
					}
				}).then((res) => {
					this.headBg = this.$api.baseUrl + this.$api.imgPath + res.data.result[0].pcImageUrl;
				})
			},
			//获取新闻列表
			getNewsList() {
				this.$request({
					url: this.$api.news.getNewsList,
					data: {
						newsTypeId: this.$route.query.newsType,
						pageNo: this.current
					}
				}).then((res) => {
					this.newsList = res.data.result.records;
					this.newsListObj = res.data.result;
					this.loading = false;
				})
			},
			//获取左侧分类
			getSearchMenu() {
				this.$request({
					url: this.$api.news.getSearchMenu
				}).then((res) => {
					this.searchMenu = res.data.result;
					this.getNavName();
				})
			},
			changeGroup(index) {
				this.currentMenuGroup = index;
				this.getNavNameNotTimeOut();
				this.getNewsList();
			},
			reback() {
				window.history.go(-1);
			},
			onChange(e) {
				this.current = e;
				this.getNavNameNotTimeOut();
				this.getNewsList();
			}
		}
	}
</script>

<style scoped>
	.bg-gray {
		background: #F6F7FC;
	}


	.nav {
		width: 1200px;
		height: 100px;
		background: #FFFFFF;
		opacity: 1;
		border-radius: 8px;
		margin-top: -50px;
		padding: 40px;
		font-size: 16px;
		display: flex;
		justify-content: space-between;
	}

	.head-bg {
		width: 100%;
		height: 300px;
	}

	.head-bg h2 {
		font-size: 36px;
		padding-top: 115px;
	}

	.head-bg p {
		font-size: 24px;
	}

	.main {
		margin-top: 15px;
	}

	.main .slide {
		width: 280px;
		float: left;
		background: #FFFFFF;
		border-radius: 8px;
		margin-bottom: 15px;
	}

	.main .slide .item {
		font-size: 18px;
		border-bottom: 1px solid #F0F2FC;
	}

	.main .slide .item .title {
		padding: 20px 40px;
		font-weight: bold;
		cursor: pointer;
	}

	.main .slide .item .title .line {
		display: none;
	}

	.main .slide .active .title .line {
		display: block;
	}

	.main .slide .item .item-content {
		background-color: #F0F2FC;
		padding: 18px 30px;
		display: none;
	}

	.main .slide .active .item-content {
		display: block;
	}

	.main .slide .item .item-content ul {
		border-left: 2px solid #DBDCE6;
		padding-left: 15px;
	}

	.main .slide .item .item-content ul li {
		list-style: none;
		font-size: 16px;
		margin-bottom: 18px;
	}

	.main .slide .item .item-content ul li a {
		color: #999999;
	}


	.main .slide .item .item-content ul .active {
		border-left: 2px solid #13B8EE;
		padding-left: 15px;
		margin-left: -16px;
	}

	.main .slide .item .item-content ul .active a {
		color: #13B8EE;
	}

	.main .main-content {
		width: 900px;
		float: right;
		background: #FFFFFF;
		border-radius: 8px;
		padding: 40px;
	}


	.main .main-content .list .item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 23px;
		padding-top: 23px;
		border-bottom: 1px dotted #D9D9D9;
		font-size: 16px;
	}



	.main .main-content .list .item:hover {
		border-bottom: 1px dotted #13B8EE;
	}

	.main .main-content .list .item:hover a {
		color: #13B8EE;
	}

	.main .main-content .list .item a {
		color: #1A1A1A;
	}

	.main .main-content .list .item span {
		color: #999999;
	}

	.reback {
		cursor: pointer;
	}

	.reback:hover {
		color: #13B8EE;
	}

	.line {
		width: 4px;
		height: 24px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
	}

	.clear {
		clear: both;
	}
</style>


// WEBPACK FOOTER //
// src/pages/news/list.vue